import React from 'react';
import { Link } from 'react-router-dom';


import otterize01 from '../../assets/imgs/otterize/otterize-colors-img.png'; 
import otterize02 from '../../assets/imgs/otterize/otterize-cube-logo-img.png'; 
import otterize03 from '../../assets/imgs/otterize/otterize-cubes-img.png'; 
import otterize04 from '../../assets/imgs/otterize/otterize-panel-img.gif'; 
import otterize06 from '../../assets/imgs/otterize/otterize-service-panel-img.gif'; 
import otterize07 from '../../assets/imgs/otterize/otterize-service-panel-img.png'; 
import otterize08 from '../../assets/imgs/otterize/otterize-service-panel-lines.png'; 
import otterize09 from '../../assets/imgs/otterize/otterize-service-panel-transparent.png'; 
import otterize10 from '../../assets/imgs/otterize/otterize-statuses-img.png'; 

import arrows from '../../assets/imgs/arrows/cover-img.png'; 


const NavinaWebAnimationsPage = () => {

  return (
        <div className='bg-light'>
          <div className='header-height'></div>
                <div className='row'>
                <div className='col-sm-2 col-xs-none'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row px-3 px-sm-5'>
                  <div className='col-md-4 text-start mb-5 me-4 '>
                    <p className='fs-2 fw-normal lh-sm capitalize mb-2'>Otterize Animated Explainer Video</p>
                    <p className='fs-1rem fw-light capitalize'>
                    3D prodcut explainer video
                    </p>
                    <p className='mt-4 fw-light'>2023</p>

                  </div>
                  <div className='col-md'>
                    <p className='fw-normal fs-5'>
                      This project involved the design and development of a series of interactive web animations for Navina’s platform and website, helping to showcase its AI-powered solutions for mastering value-based workflows. Utilizing Lottie format and motion design principles, the animations were designed to enhance usability, engagement, and platform navigation, while ensuring seamless performance across all devices.
                    </p>
                  </div>
    
                <div className='my-3 my-sm-5'></div>
                <video width="100%" height="auto" controls loop>
                  <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/Otterize.mp4" type="video/mp4" />
                </video>
          </div>
        </div>



      <div className='row mx-0 my-2 my-sm-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12'></div>
          <div className='col-sm-6 col-xs-12 my-5 py-5'>
            <h5 className='mb-4'>Bringing Navina’s Brand Identity to Life Through Animation
            </h5>
              <p className='fs-5 fw-normal'>
                Navina’s brand identity embraces minimalism, clean 2D design, and a signature palette of purple and green, creating a modern and intuitive visual language. The web animations were crafted to seamlessly align with this identity, incorporating soft, rounded shapes, smooth transitions, and layered overlays to enhance clarity and user interaction.
              </p>
              <br></br>
              <p className='fs-5 fw-normal'>
              The project included a series of 15 looped animations for the company’s website, designed to visually demonstrate key product features. Additionally, a second series of 10 animations and tutorial guides was created to assist users in navigating the platform within their preferred EHR, ensuring a smooth and intuitive onboarding experience.              </p>
        </div>
      </div>


        </div>
          <div className='col-sm-6 col-xs-12'>
        </div>

      <div className='row g-4 p-1 p-sm-5 m-0'>
      <div className='col-md col-xs-12'>
      <img className='py-2' src={otterize06} width='100%'/>

        <img className='py-2' src={otterize01} width='100%'/>
      </div>
      <div className='col-md col-xs-12'>
        <img className='py-2' src={otterize02} width='100%'/>
        <img className='py-2' src={otterize03} width='100%'/>
      </div>
 




      <div className='row mx-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12 mt-5 py-5'>
          <p className='fs-5'>
            The brief contained two parts. The first involved creating the website animations, designed for each of the product tabs: Risk Adjustment, Quality Management, Chart Review, and Analysis Dashboard. The second part focused on developing a version of the animations for users within the platform, helping them navigate the product and find relevant resources during their onboarding experience.
          </p>
          </div>
          </div>
          </div>


        <div className='p-0 '>
          <img className='' src={otterize04} width='100%'/>
      </div>





      <div className='row m-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12'></div>
          <div className='col-sm-6 col-xs-12 my-5 py-5'>
            <h5 className='mb-4'>Bringing Navina’s Brand Identity to Life Through Animation
            </h5>
              <p className='fs-5 fw-normal'>
                Navina’s brand identity embraces minimalism, clean 2D design, and a signature palette of purple and green, creating a modern and intuitive visual language. The web animations were crafted to seamlessly align with this identity, incorporating soft, rounded shapes, smooth transitions, and layered overlays to enhance clarity and user interaction.
              </p>
        </div>
      </div>


      <div className='row g-4 p-1 p-sm-5 m-0'>
      <div className='col-md col-xs-12'>
        <img className='py-2' src={otterize07} width='100%'/>
      </div>
      <div className='col-md col-xs-12'>
        <img className='py-2' src={otterize09} width='100%'/>
        <img className='py-2' src={otterize08} width='100%'/>

      </div>
      </div>



<div className='row py-5 px-3 px-sm-5'>
  <div className='col-sm-2 col-xs-12'></div>
    <div className='col-sm col-xs-12'>

  <div className='py-2'>
    <Link to={"https://otterize.com"}>
        <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
          <h5 className='fs-18 fw-600'>Client: Otterize</h5>
            <div className='arrow-out'></div>
              </a>
                </Link>
            </div>


    <div className='py-2'></div>
      <div className='d-block'>

      </div>

    <div className='py-2'></div>

    <div className='row'>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
            <li className='py-1'>Animated Explainer Video</li>
            <li className='py-1'>3D Aniamtion</li>
            <li className='py-1'>UX/UI</li>
          </ul>
      </div>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Maya</li>
            <li className='py-1'>Photosop</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Audition</li>

          </ul>
      </div>
      
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Cooperation</h5>
          <ul className='p-0'>
            <li className='py-1'>Project</li>
          </ul>
      </div>

      <div className='col-sm col-xs-12'>
        <h5 className='fw-600'>Industry</h5>
            <li className='py-1'>Technology, Cyber Security</li>
            <h5 className='fw-600 pt-2'>Duration</h5>
            <li className='py-1'>1.5 Months</li>
        </div>
      </div>
    </div>
  </div>

  <div className='row mx-0 mt-3 mt-sm-5'>
    <div className='col-sm-12 col-xs-12 text-end p-5'>
        <Link to={"/arrows"}>
          <a className='fs-5 fw-bold text-dark'>
            Next work 
            <div className='arrow-right'></div>
            </a>
              </Link>
          </div>
          <div className='col-sm-2 col-xs-12 p-3 p-sm-5'>

          </div>
            <div className='col-sm col-xs-12 p-0'>
            <Link to={"/arrows"}>
              <div className='image-box-300'>
                <img src={arrows} alt="prodbo next" />
              </div>
            </Link>
          </div>
        </div>


    </div>


  );
};

export default NavinaWebAnimationsPage;
